import React, { useEffect } from "react";

// ui components
import "react-datepicker/dist/react-datepicker.css";

import styled from "styled-components";
import { RootState } from "../../store/rootReducer";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { JenisLembaga } from "../../interfaces/JenisLembaga";
import { getJenisLembagaAsync, selectJenisLembaga } from "../../reducers/jenisLembaga/jenisLembaga.actions";
import { getStatusLabel } from "../../store/helpers";
import { PermissionMenuName } from "../../interfaces/UserRole";
// @ts-ignore
import { MUIDataTableMeta } from "mui-datatables";
import Datatables from "../../layouts/Datatables";
import { Tooltip } from '@mui/material';
import Zoom from '@mui/material/Zoom';

export const JenisLembagaListPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isLoading = useSelector((state: RootState) => state.jenisLembaga.isLoading);
  const errorMessage = useSelector((state: RootState) => state.jenisLembaga.errorMessage);
  const listJenisLembaga = useSelector((state: RootState) => state.jenisLembaga.listJenisLembaga);
  const role = useSelector((state: RootState) => state.authorization.systemAccess[PermissionMenuName.masterData].ACCESS);

  useEffect(() => {
    dispatch(getJenisLembagaAsync.request());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const createJenisLembaga = () => {
    dispatch(selectJenisLembaga(null));
    history.push(`/jenis-lembaga/create`);
  }

  const editJenisLembaga = (jenisLembaga: JenisLembaga) => {
    dispatch(selectJenisLembaga(jenisLembaga));
    history.push(`/jenis-lembaga/${jenisLembaga.ID}`);
  }

  const refresh = () => {
    if (isLoading) return;
    dispatch(getJenisLembagaAsync.request());
  }

  const renderJenisLembaga = () => {
    if (errorMessage) {
      return (
        // <tr>
        //   <td colSpan={4} style={{textAlign: 'center'}}>
        //   Terdapat kesalahan dalam memuat data: <b>{errorMessage}</b><br/><button className="btn btn-primary btn-xs" onClick={refresh}>Coba Perbaharui Halaman</button>
        //   </td>
        // </tr>

        <div style={{textAlign: 'center'}}>
          Terdapat kesalahan dalam memuat data: <b>{errorMessage}</b><br/><button className="btn btn-primary btn-xs" onClick={refresh}>Coba Perbaharui Halaman</button>
        </div>
      )
    }

    if (isLoading) {
      return (
        // <tr>
        //   <td colSpan={4} style={{textAlign: 'center'}}>
        //     Sedang memuat data &nbsp; <i className="fa fa-refresh fa-spin"></i>
        //   </td>
        // </tr>

        <div style={{textAlign: 'center'}}>
          Sedang memuat data &nbsp; <i className="fa fa-refresh fa-spin"></i>
        </div>
      );
    }

    if (listJenisLembaga.length === 0) {
      return (
        // <tr>
        //   <td colSpan={4} style={{textAlign: 'center'}}>
        //     Data tidak ditemukan: &nbsp; <button className="btn btn-primary btn-xs" onClick={refresh}>Coba Perbaharui Halaman</button>
        //   </td>
        // </tr>

        <div style={{textAlign: 'center'}}>
          Data tidak ditemukan: &nbsp; <button className="btn btn-primary btn-xs" onClick={refresh}>Coba Perbaharui Halaman</button>
        </div>
      );
    }
    
    // return listJenisLembaga.map((jenisLembaga, index) => {
    //   return (
    //     <tr key={jenisLembaga.ID}>
    //       <td>{index + 1}</td>
    //       <td>{jenisLembaga.CO_TYP_NAME}</td>
    //       <td>{getStatusLabel(jenisLembaga.STATUS)}</td>
    //       <th>
    //         <button className="btn btn-primary btn-xs" onClick={() => editJenisLembaga(jenisLembaga)}>
    //           <i className="fa fa-edit" aria-hidden="true"></i>
    //         </button>
    //       </th>
    //     </tr>
    //   );
    // })

    const items = listJenisLembaga.map((item, index) => ({
      NO: index + 1,
      id: item.ID,
      STATUS_DESC: getStatusLabel(item.STATUS),
      ...item,
    }));

    const getHeaderProps = (width: string, padding: string) => {
      return {
        style: {
          width: width,
          maxWidth: width,
          padding: padding
        },
      };
    };

    const getCellProps = (width: string, padding: string, align: string) => {
      return {
        style: {
          width: width,
          maxWidth: width,
          padding: padding,
          fontSize: '12px',
          textAlign: `${align}`
        },
      };
    };

    const actionRenderer = (value: any, tableMeta: MUIDataTableMeta) => {
      const row = items[tableMeta.rowIndex];

      return (
        <div style={{display: 'flex'}}>
          <Tooltip title="Ubah"
            slots={{
              transition: Zoom,
            }} 
            componentsProps={{
              tooltip: {
                sx: {
                  fontSize: '11px'
                },
              },
            }}>
            <button className="btn btn-primary btn-xs" onClick={() => editJenisLembaga(row)}>
              <i className="fa fa-edit" aria-hidden="true"></i>
            </button>
          </Tooltip>
        </div>
      );
    }

    const columns = [
      {
        name: "NO",
        label: "No",
        options: {
          filter: false,
          sort: true,
          setCellHeaderProps: () => getHeaderProps('50px', '5px 0 5px 0'),
          setCellProps: () => getCellProps('50px', '5px 0 5px 10px', 'left')
        },
      },
      {
        name: "CO_TYP_NAME",
        label: "Nama",
        options: {
          filter: true,
          sort: true,
          setCellHeaderProps: () => getHeaderProps('70%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('70%', '5px 0 5px 10px', 'left')
        }
      },
      {
        name: "STATUS_DESC",
        label: "Status",
        options: {
          filter: true,
          sort: true,
          setCellHeaderProps: () => getHeaderProps('20%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('20%', '5px 0 5px 10px', 'left')
        }
      },
      { 
        name: "actions",
        label: " ",
        options: {
          filter: false,
          sort: false,
          download: false,
          setCellHeaderProps: () => getHeaderProps('9%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('9%', '5px 0 5px 10px', 'left'),
          customBodyRender: actionRenderer
        },
      }
    ];
    
    return (
      <Datatables data={items} col={columns} title={'Daftar Jenis Lembaga'} />
    )
  }

  return (
    <JenisLembagaListPageWrapper>
      <section className="content">
        <div className="row">
          <div className="col-lg-6">
            <div className="box">
              <div className="box-header" style={{marginTop: '4px'}}>
                <h3 className="box-title">Daftar Jenis Lembaga</h3>

                <div className="box-tools">
                  <button
                    disabled={!role.create}
                    className="btn btn-primary"
                    onClick={createJenisLembaga}
                  >
                    Tambah Baru
                  </button>
                </div>
              </div>
              {/* <div className="box-body table-responsive no-padding">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Nama</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    { renderJenisLembaga() }
                  </tbody>
                </table>
              </div> */}

              <div style={{padding: '0 10px 10px 10px'}}>
                { renderJenisLembaga() }
              </div>
            </div>
          </div>
        </div>
      </section>
    </JenisLembagaListPageWrapper>
  );
};

const JenisLembagaListPageWrapper = styled.div``;
